<template>
<div class="md-layout">
    <div class="md-layout-item md-size-35 md-small-size-hide">
      <main-table :data="data" :lease="true" />
    </div>
    <div class="md-layout-item md-size-65 md-small-size-100">
        <tree-map-cost :data="data" pre="com"/>
    </div>
</div>
</template>

<script>
import MainTable from '@/components/MainTable';
import TreeMapCost from '@/components/Graphs/TreeMapCost';

export default {
  name: 'commercial-cost',
  components: {MainTable, TreeMapCost},
  props:['data'],
}
</script>
<style>
.table-default{
    font-weight: bold;
    background-color: #eee;
}
.gross-margin-table .title{
    font-weight: bold;
    text-align: center;
    border-right: 1px solid #ddd;
}
.gross-margin-table .md-table-cell{
    padding: 5px;
    font-size:12px;
    height: 33px;
}
</style>
